import React, { useState, ReactNode, useEffect } from 'react';
import { Layout } from 'antd';
import HeaderUser from '../../Pages/common/Header';
import Footeruser from '../../Pages/common/Footer';

const { Content } = Layout;

interface MasterProps {
    children: ReactNode;
}



const FrontendMaster: React.FC<MasterProps> = ({ children }) => {

    const [collapsed, setCollapsed] = useState(false);
    const [hover, setHover] = useState(false);
    // const [headerName, setHeaderName] = useState('');
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    
    const SecondStyle = !isSmallScreen && hover ? '80px' : '';

    const headerStyle = {
        marginLeft: `${SecondStyle}`,
    };

    const handleResize = () => {
        if (window.innerWidth <= 900) {
            setIsSmallScreen(true);
            setCollapsed(false);
        }
        else {
            setIsSmallScreen(false);
        }
    };

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [children]);



    return (
        <>
            <Layout>
                <Layout style={{ ...headerStyle , backgroundColor: '#fff' }}>
                    <HeaderUser />
                   
                    <Content >
                        {children}
                    </Content>
                    <Footeruser />
                </Layout>
            </Layout>
        </>
    );
};

export default FrontendMaster;
